const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg4Timelogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 140 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m10.893 10.849c-5.2927.58772-9.1094 2.2525-9.1094 4.2143s3.8167 3.6266 9.1094 4.2143c-.14711-1.3247-.22684-2.7418-.22684-4.2143 0-1.4728.07973-2.89.22684-4.2143",
    style: {
      fillRule: "evenodd",
      fill: "#00338d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.107 1.7396c-7.3582 0-13.323 5.9651-13.323 13.324 0-2.4529 5.9651-4.4411 13.323-4.4411 1.4728 0 2.89.0797 4.2143.22683-.58773-5.2931-2.2525-9.1094-4.2143-9.1094",
    style: {
      fillRule: "evenodd",
      fill: "#5bc6e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.321 19.277c5.2931-.58773 9.1094-2.2525 9.1094-4.2143s-3.8164-3.6266-9.1094-4.2143c.14711 1.3247.22684 2.7414.22684 4.2143s-.07973 2.89-.22684 4.2143",
    style: {
      fillRule: "evenodd",
      fill: "#6e273d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.107 28.387c7.3586 0 13.324-5.9651 13.324-13.324 0 2.4529-5.9651 4.4411-13.324 4.4411-1.4728 0-2.8896-.0797-4.2139-.22683.58738 5.2927 2.2521 9.1094 4.2139 9.1094",
    style: {
      fillRule: "evenodd",
      fill: "#e21776"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m82.22 10.655v8.8254h-3.8188c-2.6652 0-4.2252-1.8126-4.2252-4.4129 0-2.6003 1.56-4.4125 4.2252-4.4125zm-1.9992 6.8259v-4.8264h-1.8196c-1.8274 0-2.2257.61666-2.2257 2.413 0 1.7964.39828 2.4134 2.2257 2.4134z",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.693 18.658v3.5528h-1.9992v-11.556h4.3956c2.825 0 3.8834 1.7935 3.8834 4.4126 0 2.619-1.0583 4.4125-3.8834 4.4125-.87877 0-1.7378-.24941-2.3964-.82232zm0-6.0036v2.4134c0 1.7357.35067 2.4134 2.1403 2.4134 1.7893 0 2.1403-.67769 2.1403-2.4134 0-1.7357-.35101-2.4134-2.1403-2.4134z",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m52.278 19.481c-2.6652 0-4.2249-1.8122-4.2249-4.4126 0-2.6007 1.5596-4.4129 4.2249-4.4129 2.6652 0 4.2249 1.8126 4.2249 4.4129 0 2.6-1.5596 4.4126-4.2249 4.4126zm0-1.9992c1.8274 0 2.2257-.617 2.2257-2.4134 0-1.7963-.39828-2.4134-2.2257-2.4134s-2.2257.61665-2.2257 2.4134c0 1.7964.39794 2.4134 2.2257 2.4134",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.59 19.481v2.7305h-1.9992v-2.7305h-.26776c-2.6652 0-4.2252-1.8122-4.2252-4.4126 0-2.6007 1.56-4.4129 4.2252-4.4129h2.5347c2.6652 0 4.2252 1.8122 4.2252 4.4129 0 2.6003-1.56 4.4126-4.2252 4.4126zm0-6.8259v4.8267h.26776c1.8274 0 2.2257-.617 2.2257-2.4134 0-1.7967-.39828-2.4134-2.2257-2.4134zm-1.9992 4.8267v-4.8267h-.26776c-1.8277 0-2.2257.61665-2.2257 2.4134 0 1.7964.39793 2.4134 2.2257 2.4134z",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m89.631 17.481v-6.8259h1.9992v8.8251h-3.5765c-2.6652 0-4.2252-1.8119-4.2252-4.4125v-4.4126h1.9992l.00026 4.4126c0 1.7967.39793 2.4134 2.2257 2.4134z",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.96 15.01h-.043l-1.9798 3.3447h-2.3851l-1.9798-3.3447h-.043v4.4711h-1.9992v-8.8254h1.9389l3.2251 5.7852h.10089l3.2258-5.7852h1.9385v8.8254h-1.9992z",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m71.102 12.655v6.8259h-1.9992v-6.8259h-2.6515v-1.9995h7.3025v1.9995z",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m90.476 7.6839c-.38947 1.1426-1.4722 1.9646-2.7467 1.9646-1.2746 0-2.3569-.82197-2.7467-1.9646z",
    style: {
      fillRule: "evenodd",
      fill: "#353735"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4Timelogo);
export default __webpack_public_path__ + "static/media/4timelogo.0ad0539cda22b9fc51b11c85d5fc4fac.svg";
export { ForwardRef as ReactComponent };